import * as cx from 'classnames'
import * as React from 'react'
import { Site } from '../../../../common/constants/siteList'

const SearchHeader = ({
  currentSite,
  children,
  styles = {}
}: {
  currentSite: Site
  children: any
  styles: any
}) => {
  const pageSectionClassNames = cx(
    styles.pageSection,
    'page-section',
    '-size-xcompact',
    `-theme-${currentSite || Site.themeforest}`
  )

  return (
    <div id="search-header">
      <div className={pageSectionClassNames}>
        <div className={cx(styles.pageSectionContent, 'page-section__content')}>
          <div
            className={cx(
              styles.pageSectionBackground,
              'page-section__background'
            )}
          />
          <div
            className={cx(
              styles.pageSectionForm,
              'search-header__form-wrapper'
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchHeader
